export default "assets/images/logo-cafe-de-paris-73cdcb54.png";